import { Stack, Typography, openFile } from "@compass/core";
import { SubmitButton } from "components";
import { SurveyExportRequest } from "generated/openApi";
import ApiService from "services/apiService";

export const CobroSurveyExportHeader = (props: {
  handle: string;
  surveyId: number | undefined;
  exportTypeId: number | undefined;
}) => {
  const exportSurveys = () => {
    const request: SurveyExportRequest = {
      formId: props.surveyId!,
      formExportTypeId: props.exportTypeId!,
    };
    ApiService.surveyExport.generateSurveyReport(request).then((response) => {
      openFile(response.fileName, response.base64String, response.contentType);
    });
  };
  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center">
        <SubmitButton label="Export" onClick={() => exportSurveys()} disabled={false} />
      </Stack>
    </Stack>
  );
};
